import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { BuilderComponentSetting, UserColumnFilterValue } from '@/shared/builder'
import { UserColumnFilterRepeater } from '@/components/Builder/UserColumnFilterRepeater'

const excludeColumns = new Set([
  ColumnTypes.Address,
  ColumnTypes.URL,
  ColumnTypes.Image,
  ColumnTypes.ImageArray,
  ColumnTypes.RichText,
  ColumnTypes.Attachment,
  ColumnTypes.Icon,
  ColumnTypes.Coordinate,
  ColumnTypes.Slug,
  ColumnTypes.QRCode,
  ColumnTypes.Barcode,
  ColumnTypes.Color,
  ColumnTypes.AISEO,
  ColumnTypes.AITextProcessing,
  ColumnTypes.Connection,
  ColumnTypes.Lookup,
  ColumnTypes.Function,
  ColumnTypes.Formula,
  ColumnTypes.Math,
  ColumnTypes.Template,
  ColumnTypes.SingleCell,
])

interface UserColumnFilterFieldSettingProps {
  id: string
  settingId: string
  value: any
  columnFilterSettings: BuilderComponentSetting['columnFilterSettings']
}

const UserColumnFilterFieldSetting = ({
  id,
  settingId,
  value,
  columnFilterSettings,
}: UserColumnFilterFieldSettingProps) => {
  const tableSourceId = columnFilterSettings?.tableSourceId

  const { tables } = useDbClientContext()
  const { activeComponent, activeLayerContainer } = useActiveLayerContext()
  const updateValue = useUpdateCompSettingValue(id)

  const sourceValue: undefined | { table: string; columns: string[] } | string =
    activeComponent && tableSourceId
      ? (activeLayerContainer?.elementSettings[activeComponent.id]?.[tableSourceId] as
          | {
              table: string
              columns: string[]
            }
          | string)
      : undefined

  const tbl = typeof sourceValue === 'string' ? sourceValue : sourceValue?.table
  const table = tables?.find((tb) => tb.id === tbl)
  const columns = table?.columns ?? []

  const filteredColumns = columns.filter((c) => {
    if (c.type === ColumnTypes.Lookup) {
      const connCol = columns.find((cc) => {
        return cc.id === c?.lookup?.connColId
      })
      if (connCol) {
        const connStg = connCol.connections
        const foreignTable = tables.find((tb) => tb.id === connStg?.fTableId)
        const foreignColumn = foreignTable?.columns.find((fc) => fc.id === c?.lookup?.colId)
        return foreignColumn && !excludeColumns.has(foreignColumn.type)
      } else {
        return false
      }
    }
    return !excludeColumns.has(c.type)
  })

  return table ? (
    <UserColumnFilterRepeater
      id={settingId}
      value={(value as UserColumnFilterValue[]) ?? []}
      table={table}
      colOptions={filteredColumns}
      onChange={async (next) => {
        await updateValue(next as any)
      }}
    />
  ) : null
}

export default UserColumnFilterFieldSetting
